// Compact ad-performance payload sent to the Claude backends (chat, suggestions).
export function buildAdDataPayload(insights) {
  if (!insights) return null;
  return Object.fromEntries(
    Object.entries(insights.byChannel)
      .filter(([, data]) => (data.ads || []).length > 0)
      .map(([channel, data]) => [channel, {
        anzeigen: data.ads.slice(0, 30).map((ad) => ({
          name: ad.name,
          kampagne: ad.campaign,
          spend: +ad.spend.toFixed(2),
          käufe: ad.purchases,
          kaufwert: +ad.purchaseValue.toFixed(2),
          roas: +ad.roas.toFixed(2),
          cpa: ad.cpa === null ? null : +ad.cpa.toFixed(2),
          ctr: +ad.ctr.toFixed(2),
          frequenz: ad.frequency,
        })),
        kampagnen: data.campaigns.map((campaign) => ({
          name: campaign.name,
          status: campaign.status,
          spend: +campaign.spend.toFixed(2),
          kaufwert: +campaign.purchaseValue.toFixed(2),
          roas: +campaign.roas.toFixed(2),
          tagesbudget: campaign.dailyBudget === null ? null : +campaign.dailyBudget.toFixed(2),
          zielRoas: campaign.targetRoas,
        })),
      }])
  );
}
